module.exports = __webpack_public_path__ + "img/003.64c73f94.png";